import { getValueLabelOptions } from './getValueLabelOptions';

export function convertStringsToOptions(items: string[]) {
    return getValueLabelOptions<string>(
        items,
        items => items,
        items => items,
    );
}
